import React, {useEffect, useState} from 'react';
import Popup from "../Popup";
import FormHeader from "../form/Header";
import {useTranslation} from "react-i18next";
import {CentsToDollars} from "../../utils/formatPrice";
import {GetBatchSellOrder} from "../../api/batch-order/getBatchSellOrder";
import {formatDate} from "../../utils/formatDate";

const ViewOrder = ({order, onClose, ...props}) => {
    const { t } = useTranslation();
    const [fullOrder, setFullOrder] = useState('');
    const [loading, setLoading] = useState(false);

    const getFullOrder = async () => {
        if(order.id){
            setLoading(true);
            try {
                const {data} = await GetBatchSellOrder({id:order.id});
                setFullOrder(data);
            }catch (err){
                console.log("Full order couldn't be fetched. " +  err.message);
            }
            setLoading(false)
        }
    }

    useEffect(()=> {
        getFullOrder();
    }, []);
    return (
        <Popup size="large" withClose withOverlay onClose={onClose}>
            <FormHeader title={`Order ID: ${order.id}`}></FormHeader>
            <div className="mt-5">
                <p>{t("Order Number")}: <strong>{order.id}</strong></p>
                <p>{t("Date")}: <strong>{formatDate(order.created_at)}</strong></p>
                <p>{t("Order Type")}: <strong>{order.type}</strong></p>
                <p>{t("Order Status")}: <strong>{order.status}</strong></p>
                <p>{t("User")}: <strong>{order.created_by_name}</strong></p>
                <p>{t("Total Purchase Amount")}: <strong>{CentsToDollars(order.total_cost)}</strong></p>
                <p>{t("Office Name")}: <strong>{order.office_name}</strong></p>
                <p>{t("Start PRN")}: <strong>{order.start_processor_reference}</strong></p>
                <p>{t("End PRN")}: <strong>{order.end_processor_reference}</strong></p>
                <p>{t("Quantity")}: <strong>{order.quantity}</strong></p>
                {loading && t("Loading additional data...")}
                {!loading && fullOrder &&
                    <>
                        {fullOrder.cards.length > 0 && <div className="mb-1">
                            <p>{t("Cards")}:</p>
                            <table>
                                <thead>
                                <tr>
                                    <th>{t('PRN Number')}</th>
                                    <th>{t('Amount')}</th>
                                    <th>{t('Status')}</th>
                                </tr>
                                </thead>
                                <tbody>
                                {fullOrder.cards.map((card) => (
                                    <tr key={card.processor_reference}>
                                        <td>{card.processor_reference}</td>
                                        <td>{CentsToDollars(card.load_amount)}</td>
                                        <td>{card.status}</td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                        }

                        {fullOrder.payments.length > 0 && <div className="mb-1">
                            <p>{t("Payments")}:</p>
                            <table>
                                <thead>
                                <tr>
                                    <th>{t('Type')}</th>
                                    <th>{t('Confirmation Code')}</th>
                                    <th>{t('Amount')}</th>
                                </tr>
                                </thead>
                                <tbody>
                                {fullOrder.payments.map((payment) => (
                                    <tr key={payment.id}>
                                        <td>{payment.payment_type}</td>
                                        <td>{payment.confirmation_code}</td>
                                        <td>{CentsToDollars(payment.amount)}</td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                        }
                    </>
                }
            </div>
        </Popup>
    );
};

export default ViewOrder;
